__turbopack_context__.v({
  "description": "yRCLpG_description",
});
